<template>
  <div class="container-fluid task-images-container">
    <input v-if="galleryOptions !== null" v-file-uploader="galleryOptions" type="file" name="files" class="gallery_media" />
  </div>
</template>

<script>
import VueFileUploader from "@/directives/VueFileUploader.js";
export default {
  name: "TaskImages",
  components: {},
  directives: {
    VueFileUploader
  },
  props: ["venueTaskId", "imageUrls"],
  data() {
    return {
      galleryOptions: null
    };
  },
  mounted() {
    const files = this.imageUrls.map(imageUrl => ({
      name: "taskImage.jpg",
      size: 1,
      type: "image/jpg",
      file: imageUrl,
      data: {
        url: imageUrl
      }
    }));

    this.galleryOptions = {
      deletingImage: false,
      uploadUrl: process.env.VUE_APP_API_BASE_URL + "/VenueTasksImages/" + this.venueTaskId,
      deleteUrl: process.env.VUE_APP_API_BASE_URL + "/VenueTasksImages/" + this.venueTaskId,
      sortUrl: process.env.VUE_APP_API_BASE_URL + "/VenueTasksImages/" + this.venueTaskId,
      files: files
    };
  },
  beforeDestroy: function () {},
  methods: {}
};
</script>

<style lang="scss">
.container-fluid.task-images-container {
  .fileuploader-items {
    .fileuploader-items-list {
      .fileuploader-item {
        width: 40%;
        margin: 12px auto;
      }
      .type-holder {
        display: none;
      }

      .fileuploader-input {
        width: 100%;
      }
    }
  }
  .fileuploader-theme-gallery .fileuploader-input-inner {
    /*max-height:90px !important;*/
    min-height: 100px !important;
  }
}
</style>